export const CHART_TYPES = {
  BAR_CHART: 'barChart',
  WORD_CLOUD: 'wordCloud',
  PIE_CHART: 'pieChart',
  WORLD_MAP: 'worldMap',
};

export const CHARTS_YEARS_RANGE = {
  min: new Date().getFullYear() - 10,
  max: new Date().getFullYear(),
};


// WEBPACK FOOTER //
// ./src/views/dashboard/constants.js